import type { NavItem } from '@/app/shells/cabinet/types/NavItem';

/**
 * The cabinet pages the sidebar does not list: the title their tab carries, and the entry they
 * belong under, which stays lit on them. "Resurse salvate" is reached from "Rapoarte și publicații"
 * and from the public library, where the reader saves (SL-2F).
 */
export const UNLISTED_PAGES: (Pick<NavItem, 'to' | 'label'> & { under: string })[] = [
  { to: '/app/biblioteca', label: 'pageSavedResources', under: '/app/publicatii' },
];

/** Whether a sidebar entry stays lit on the page at `pathname`, one that belongs under it. */
export function alsoActive(item: Pick<NavItem, 'to'>, pathname: string): boolean {
  return UNLISTED_PAGES.some(
    (page) =>
      page.under === item.to && (pathname === page.to || pathname.startsWith(`${page.to}/`)),
  );
}
